import { Tariff } from '../interface/dto/Tariffs';

export const getEligiblePrice = (subscription: Tariff) => {
    const { discount } = subscription;

    const hasDiscount = discount && 0 < discount.monetary.length;
    const withDiscount = subscription?.prices?.composition?.tariff?.month?.withDiscounts;
    const gross = hasDiscount && withDiscount ?
        subscription?.prices?.composition?.tariff?.month?.withDiscounts[0].gross
        : subscription?.prices?.composition?.tariff?.month?.withoutDiscounts?.gross;

    return gross;
};
